<template>
	<v-dialog v-model="child_dialog" max-width="80%">
			<app-card>
				<app-section-loader :status="form_loader"></app-section-loader>
				<h4>PHIẾU ĐIỀU CHỈNH</h4>
				<p class="fs-14 grey--text">Tạo phiếu điều chỉnh</p>
				<v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    :rules="[rules.required]"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-autocomplete
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    :rules="[rules.required]"
                                    required
                                    @change="findDebt()"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_receipt_data_month"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.month"
                                        label="Chọn tháng"
                                        :disabled="loading.submit"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <v-date-picker
                                        min="2019-10"
                                        locale="vi-VI"
                                        type="month"
                                        v-model="form.month"
                                        @change="findDebt()"
                                        @input="menu_receipt_data_month = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_receipt_date_collected"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.adjustment_date"
                                        label="Ngày điều chỉnh"
                                        :disabled="true"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 v-if="alert.show">
                                <v-alert
                                    :value="alert.show"
                                    :type="alert.type"
                                    outline
                                >{{ alert.text }}</v-alert>
                            </v-flex>
                            <template v-if="form.room_state_id">
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Số tiền điều chỉnh"
                                        :disabled="loading.submit"
                                        v-model="form.amount"
                                        prepend-icon="money"
                                        required
                                        :rules="[rules.required, rules.max_collected_amount]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Loại điều chỉnh"
                                        :disabled="loading.submit"
                                        v-model="form.type"
                                        :items="ADJUSTMENT_TYPE_OPTIONS"
                                        prepend-icon="event_note"
                                        required
                                        :rules="[rules.required]"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-text-field
                                        label="Ghi chú"
                                        :disabled="loading.submit"
                                        v-model="form.note"
                                        prepend-icon="event_note"
                                    ></v-text-field>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-container>
                    <v-card-actions v-if="form.room_state_id">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="loading.submit" @click="cancelInput">Trở về</v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >Tạo phiếu Điều chỉnh</v-btn>
                    </v-card-actions>
                </v-form>
			</app-card>
		</v-dialog>
</template>

<script>
import api from "Api";
import {
	buildParamQuery,
} from "Helpers";
import { list_building, ADJUSTMENT_TYPE_OPTIONS } from "Constants/db-config";
import { Wallet } from "Components/Form";

export default {
	name: "dialog-tao-phieu-dieu-chinh",
	props: {
		dialog: Boolean,
	},
	components: {
		Wallet
	},
	data() {
		return {
			child_dialog: false,
			form_loader: false,
			menu_month_picker: false,
			menu_date_collected: false,
			over_amount_allowed: 200000,
			rules: {
				required: value => !!value || "Vui lòng điền thông tin này."
			},
			form: {
                building: "",
                room_id: "",
                adjustment_date: new Date().toISOString().substr(0, 10),
                note: "",
                room_state_id: "",
                month: "",
                amount: "",
                wallet_account_id: null
            },
			list_building,
			loading: {
                submit: false
            },
			alert: {
                show: false,
                text: "",
                type: "error"
            },
            ADJUSTMENT_TYPE_OPTIONS,
		};
	},
	computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        room_ids() {
            return this.rooms.filter(
                room => room.building === this.form.building
            );
        },
        filtered_items() {
            return this.items.filter(item => {
                if (!this.chosen_payment_type) return true;
                else if (
                    this.chosen_payment_type == "cash" &&
                    item.wallet_account_id == 1
                )
                    return true;
                else if (
                    this.chosen_payment_type == "bank" &&
                    item.wallet_account_id != 1
                )
                    return true;
                return false;
            });
        }
    },
	watch: {
		"form.amount": function(nv, ov) {
			this.formatMoney();
		},
		dialog(nv){
            if (nv) {
                this.form = {
                    building: "",
                    room_id: "",
                    adjustment_date: new Date().toISOString().substr(0, 10),
                    note: "",
                    room_state_id: "",
                    month: "",
                    amount: "",
                    wallet_account_id: null
                };
            };
			this.child_dialog = this.dialog;
		},
		child_dialog(nv) {
			this.$emit("changeDialogState", nv);
		},
	},
	methods: {
		formatMoney: function() {
			let amount = this.form.amount;
			amount = amount
				? amount
						.toString()
						.replace(/,/g, "")
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: 0;
			this.form.amount = amount;
		},
		cancelInput() {
			this.dialog = false;
			this.$refs.form.reset();
		},
		submit: async function() {
			if (!this.$refs.form.validate()) {
				swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
			}

			this.loading = true;

			const postData = {
				...this.form,
				adjustment_date: new Date(this.form.adjustment_date),
				amount: Number(
					this.form.amount.replace(/,/g, "")
				)
			};

			const data = await api.createAdjustment(postData);

			this.loading = false;

			if (data.status === 200) {
				this.dialog = false;
				this.cancelInput();
				this.$emit("getData");
				swal.fire("Thành công", data.data.message, "success");
			} else swal.fire("Lỗi", data.message, "error");
		},
		findDebt: async function() {
            if (!this.form.room_id || !this.form.month) {
                return;
            }
            this.alert.show = false;
            this.form_loader = true;
            this.form.note = "";
            this.form.room_state_id = "";
            this.form.amount = "";
            const params = {
                roomId: this.form.room_id,
                month: this.form.month
            };
            const query = buildParamQuery(params);
            const data = await api.searchDebt(query);
            this.form_loader = false;
            if (data.status === 200 && data.data) {
                this.form.amount = -data.data.debt;
                this.form.room_state_id = data.data.room_state_id;
				const unix_date = new Date().getTime();
            } else {
                this.alert.show = true;
                this.alert.text = `Không có chênh lệch cần điều chỉnh cho phòng ${this.form.room_id} vào tháng ${this.form.month}`;
            }
        },
	}
};
</script>

<style>
</style>